import { BASE_PATH } from 'src/utils/routes'

const IMAGE_BASE_PATH = `${BASE_PATH}/assets/images`

export const CLOSE_ICON = `${IMAGE_BASE_PATH}/close-bt@3x-min.png`
export const DEFAULT_IMAGE = `${IMAGE_BASE_PATH}/default_story.jpg`
export const FOOTER_ARROW = `${IMAGE_BASE_PATH}/arrow_footer.png`
export const PUBLISHED = `${IMAGE_BASE_PATH}/published.jpg`
export const MAINTENACE = `${IMAGE_BASE_PATH}/maintenance.png`

export const CONTIRBUTION_BACKGROUND = `${IMAGE_BASE_PATH}/contribution_bg.png`

export const UPDATE_NEEDS = `${IMAGE_BASE_PATH}/needs_update_popup.png`

export const ATTENTION_1 = `${IMAGE_BASE_PATH}/attention_message_icon1.png`
export const ATTENTION_2 = `${IMAGE_BASE_PATH}/attention_message_icon2.png`
export const ATTENTION_3 = `${IMAGE_BASE_PATH}/attention_message_icon3.png`

export const APP_STORE_QRCODE = `${IMAGE_BASE_PATH}/mobile-app-qr-code-for-ios.png`
export const PLAY_STORE_QRCODE = `${IMAGE_BASE_PATH}/mobile-app-qr-code-for-android.png`
export const APP_MOCK = `${IMAGE_BASE_PATH}/mobile-app-mockup-sp.png`

export const PAID_MEMBER_TOP_BACKGROUND_WIDE =
  'https://assets.onlystory.co.jp/assets/members/fv-bg@2x-min-fb46426b01cfb14013c7e024b3c8e82fa30622ac102dc71b0ebb8ba4c407163f.png'
export const PAID_MEMBER_TOP_BACKGROUND_NARROW =
  'https://assets.onlystory.co.jp/assets/members/sp/fv-bg-sp@2x-min-3eaa4007f15d6c111c8f1070a2e6c226f962138b4d9df897b5c007e404d52220.png'
export const PAID_MEMBER_TOP_LOGO =
  'https://assets.onlystory.co.jp/assets/members/fv-rogo@2x-min-6ba0163f063c5c2d9984aaeb7766ecdb04c1e600fb56a5bc6c31be2d85488038.png'
export const DOWN_ARROW =
  'https://assets.onlystory.co.jp/assets/members/icon/fv-arrow-sp@3x-min-d896cb133f643c761e1040bf6b742daba5e0e27907d46bf3db55db660f754b66.png'

export const EVENT_BACKGROUND_LEFT = `${IMAGE_BASE_PATH}/event_left_bg.png`
export const EVENT_BACKGROUND_RIGHT = `${IMAGE_BASE_PATH}/event_right_bg.png`

export const CAMPAIGN_BACKGROUND = `${IMAGE_BASE_PATH}/campaign_bg.png`
export const BANNER_CAMPAIGN_1 = `${IMAGE_BASE_PATH}/banner_campaign_1.png`
export const BANNER_CAMPAIGN_4 = `${IMAGE_BASE_PATH}/banner_campaign_4.png`
export const BANNER_CAMPAIGN_5 = `${IMAGE_BASE_PATH}/banner_campaign_5.png`
